import { Button, Form, Input, Modal, Select } from 'antd';
import { memo, useCallback, useContext, useMemo } from 'react';
import { ConversationContext } from '../../contexts/ConversationContext';

const { Option } = Select;

const CreateGroupMemberForm = ({
  openModalCreate,
  handleCancelModalCreate,
  users,
  userId,
}) => {
  const { createGroupChat } = useContext(ConversationContext);

  const onFinish = useCallback(
    (values) => {
      createGroupChat(values);
      handleCancelModalCreate();
    },
    [createGroupChat, handleCancelModalCreate]
  );

  const formItemLayout = useMemo(
    () => ({
      labelCol: { span: 6 },
      wrapperCol: { span: 20 },
    }),
    []
  );

  return (
    <Modal
      open={openModalCreate}
      title="Create group chat"
      onCancel={handleCancelModalCreate}
      footer={[
        <Button key="back" onClick={handleCancelModalCreate}>
          Cancel
        </Button>,
      ]}
    >
      <Form name="validate_other" onFinish={onFinish}>
        <Form.Item
          {...formItemLayout}
          name="name"
          label="Group name"
          rules={[
            {
              required: true,
              message: 'Please input group name',
            },
          ]}
        >
          <Input placeholder="Please input group name" />
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          name="userIds"
          label="Select multiple"
          rules={[
            {
              required: true,
              message: 'Please select your favourite members!',
              type: 'array',
            },
          ]}
        >
          <Select mode="multiple" placeholder="Please select users">
            {users?.map(
              (user) =>
                user?.id !== userId && (
                  <Option value={user?.id} key={user?.id}>
                    {user?.fullName}
                  </Option>
                )
            )}
          </Select>
        </Form.Item>

        <Form.Item
          wrapperCol={{ span: 12, offset: 20 }}
          style={{ marginBottom: 0 }}
        >
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default memo(CreateGroupMemberForm);
